const FocusDirective = function () {
    return function (scope, element, attrs) {
        element.focus();
    };
};

export { FocusDirective };